import {
  TextField,
  MenuItem,
  Grid2 as Grid,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import PageFilters from './ui/PageFilters';

/**
 * Filtros para schedules — usa PageFilters como base estrutural.
 */
export default function ScheduleFilters({
  searchTerm,
  onSearchChange,
  filterProfessional,
  onProfessionalChange,
  filterPlace,
  onPlaceChange,
  filterStatus,
  onStatusChange,
  professionals = [],
  places = [],
  onClearFilters,
}) {
  const hasActiveFilters = searchTerm || filterProfessional || filterPlace || filterStatus;

  const statusOptions = [
    { value: '',          label: 'Todos' },
    { value: 'Active',    label: 'Ativa' },
    { value: 'Inactive',  label: 'Inativa' },
    { value: 'Scheduled', label: 'Agendada' },
    { value: 'Expired',   label: 'Expirada' },
    { value: 'Deleted',   label: 'Excluída' },
  ];

  return (
    <PageFilters onClear={onClearFilters} clearDisabled={!hasActiveFilters}>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        <TextField
          fullWidth
          size="small"
          label="Buscar por nome"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon sx={{ mr: 0.5, color: 'action.active', fontSize: 18 }} />,
          }}
          placeholder="Nome da agenda..."
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TextField
          select
          fullWidth
          size="small"
          label="Profissional"
          value={filterProfessional}
          onChange={(e) => onProfessionalChange(e.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {professionals.map((prof) => (
            <MenuItem key={prof.id} value={prof.id}>
              {prof.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TextField
          select
          fullWidth
          size="small"
          label="Local"
          value={filterPlace}
          onChange={(e) => onPlaceChange(e.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {places.map((place) => (
            <MenuItem key={place.id} value={place.id}>
              {place.name}{place.addressCity ? ` (${place.addressCity})` : ''}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 2 }}>
        <TextField
          select
          fullWidth
          size="small"
          label="Status"
          value={filterStatus}
          onChange={(e) => onStatusChange(e.target.value)}
        >
          {statusOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </PageFilters>
  );
}
